<p>
  Публичните коментари са отворена форма на комуникация, която позволява на всеки регистриран потребител да зададе
  въпрос, да изрази мнение или да потърси допълнителна информация относно конкретна обява. Всички коментари са видими за
  останалите потребители на платформата.
</p>
<p>
  Те се намират под описанието на обявата и предоставят възможност за по-добра информираност преди осъществяване на
  сделка. Коментарите могат да спомогнат за изясняване на детайли по артикула, начина на доставка или допълнителни
  условия.
</p>
<h6 class="mt-3">
  Как да добавите публичен коментар?
</h6>
<p>
  Отидете на страницата на съответната обява и натиснете бутона <strong>„Добави коментар“</strong>. Ще се отвори форма,
  в която може да напишете своето съобщение и да го изпратите.
</p>
<p>
  Коментарите се показват публично под обявата и са видими за всички потребители. <strong>Продавачът</strong> има
  възможност да отговаря директно на тях, като по този начин се създава прозрачна дискусия.
</p>
<div class="m-0 alert alert-danger"><strong>Важно:</strong> Моля, спазвайте добрия тон и бъдете уважителни. Коментари,
  съдържащи обиди, спам, нерелевантно съдържание или нарушаващи правилата на платформата, ще бъдат премахвани от
  модераторския екип.
</div>
